"use client";

import type { AccessTokenPayload } from "core";
import { createContext, use } from "react";

export type AuthenticationContextValue = { accessTokenPayload?: AccessTokenPayload; authenticated?: boolean };

export const AuthenticationContext = createContext<AuthenticationContextValue>({
  authenticated: undefined,
  accessTokenPayload: undefined,
});

export const useAuthenticationContext = () => use(AuthenticationContext);
